/* import __COLOCATED_TEMPLATE__ from './enter-amount.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import { Account } from '@square/dashboard-protos/models/squareup/banking/account_model';
import { MONEY_INPUT_ID } from '@banking/ui/utils/constants';
import { ExternalBankAccount } from '@square/dashboard-protos/models/squareup/sfs/external/models/external_bank_account';
import { AccountType } from '@square/dashboard-protos/models/squareup/banking/common';
function id(account) {
  if (account === null) {
    return 'no-linked-external';
  } else if (account instanceof Account) {
    return `${account.type}-${account.id}`;
  } else {
    return `external-${account.id}`;
  }
}
let EnterAmount = (_dec = computed('maxTransfer.amount', 'currentTransfer.customerLimits.odfiWithdrawalAmountPerTransactionMax.amount'), _dec2 = computed('currentTransfer.customerLimits.odfiDepositAmountPerTransactionMax'), _dec3 = computed('currentTransfer.{isDeposit,isFolderToFolderTransfer}', 'showDepositTransferLimit', 'showWithdrawalTransferLimit'), _dec4 = computed('currentTransfer.customerLimits.odfiWithdrawalAmountPerTransactionMax.amount', 'sfsCustomerApi.remainingWeeklyWithdrawals.amount'), _dec5 = computed('currentTransfer.customerLimits.odfiDepositAmountPerTransactionMax.amount', 'sfsCustomerApi.remainingWeeklyDeposits.amount'), _dec6 = computed('currentTransfer.isDeposit', 'maxDepositLimit', 'maxWithdrawalLimit'), _dec7 = computed('currentTransfer.{exceedsOdfiDepositLimit,exceedsOdfiWithdrawalLimit,isDeposit,isFolderToFolderTransfer}'), _dec8 = computed('secondaryOptions.length'), _dec9 = computed('secondaryOptions'), _dec10 = computed('externalBankAccounts.length', 'balances.length'), _dec11 = readOnly('currentTransfer.primaryAccount.availableBalance'), (_class = class EnterAmount extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentTransfer", _descriptor, this);
    _initializerDefineProperty(this, "sfsCustomerApi", _descriptor2, this);
    _initializerDefineProperty(this, "sfsAccountApi", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "features", _descriptor5, this);
    _defineProperty(this, "moneyInputId", MONEY_INPUT_ID);
    _initializerDefineProperty(this, "showValidation", _descriptor6, this);
    _initializerDefineProperty(this, "validation", _descriptor7, this);
    _initializerDefineProperty(this, "maxTransfer", _descriptor8, this);
  }
  onSubmit(event) {
    event.preventDefault();
    if (this.noOtherAccounts) {
      // This condition supersedes other validations because it cannot just be
      // fixed by updating an input and should already have validations shown
      return;
    }
    this.showValidation = true;
    this.validate();
    if (this.validation?.isValid) {
      this.args.continue();
    }
  }
  validate() {
    this.validation = this.currentTransfer.validate();
  }
  get secondaryOptions() {
    return this.currentTransfer.secondaryOptions.map(account => {
      const result = {
        account,
        id: id(account)
      };
      return result;
    });
  }
  get secondaryAccountId() {
    return id(this.currentTransfer.secondaryAccount);
  }
  get showWithdrawalTransferLimit() {
    return this.maxTransfer && this.currentTransfer.customerLimits !== undefined && this.currentTransfer.customerLimits.odfiWithdrawalAmountPerTransactionMax !== undefined && this.currentTransfer.customerLimits.odfiWithdrawalAmountPerTransactionMax.amount < this.maxTransfer.amount;
  }
  get showDepositTransferLimit() {
    return this.currentTransfer.customerLimits !== undefined && this.currentTransfer.customerLimits.odfiDepositAmountPerTransactionMax !== undefined;
  }
  get showTransferLimit() {
    if (this.currentTransfer.isFolderToFolderTransfer) {
      return false;
    }
    if (this.currentTransfer.isDeposit) {
      return this.showDepositTransferLimit;
    } else {
      return this.showWithdrawalTransferLimit;
    }
  }
  get maxWithdrawalLimit() {
    if (!this.currentTransfer.customerLimits || !this.currentTransfer.customerLimits.odfiWithdrawalAmountPerTransactionMax || !this.sfsCustomerApi.remainingWeeklyWithdrawals) {
      return undefined;
    }

    // If the remainingWeeklyWithdrawals is smaller than the per-transaction limit,
    // show remainingWeeklyWithdrawals instead.
    if (this.sfsCustomerApi.remainingWeeklyWithdrawals && this.sfsCustomerApi.remainingWeeklyWithdrawals.amount < this.currentTransfer.customerLimits.odfiWithdrawalAmountPerTransactionMax.amount) {
      return this.sfsCustomerApi.remainingWeeklyWithdrawals;
    } else {
      return this.currentTransfer.customerLimits.odfiWithdrawalAmountPerTransactionMax;
    }
  }
  get maxDepositLimit() {
    if (!this.currentTransfer.customerLimits || !this.currentTransfer.customerLimits.odfiDepositAmountPerTransactionMax || !this.sfsCustomerApi.remainingWeeklyDeposits) {
      return undefined;
    }

    // If the remainingWeeklyDeposits is smaller than the per-transaction limit,
    // show remainingWeeklyDeposits
    if (this.sfsCustomerApi.remainingWeeklyDeposits.amount < this.currentTransfer.customerLimits.odfiDepositAmountPerTransactionMax.amount) {
      return this.sfsCustomerApi.remainingWeeklyDeposits;
    } else {
      return this.currentTransfer.customerLimits.odfiDepositAmountPerTransactionMax;
    }
  }
  get maxTransferLimit() {
    if (this.currentTransfer.isDeposit) {
      return this.maxDepositLimit;
    } else {
      return this.maxWithdrawalLimit;
    }
  }
  get showTransferError() {
    if (this.currentTransfer.isFolderToFolderTransfer) {
      return false;
    }
    if (this.currentTransfer.isDeposit) {
      return this.currentTransfer.exceedsOdfiDepositLimit;
    } else {
      return this.currentTransfer.exceedsOdfiWithdrawalLimit;
    }
  }
  get balances() {
    const array = [];
    this.secondaryOptions.forEach(({
      account
    }) => {
      if (account instanceof Account && account.type !== AccountType.CLEARING_ACCOUNT) {
        array.push(account);
      }
    });
    return array;
  }
  get externalBankAccounts() {
    const array = [];
    this.secondaryOptions.forEach(option => {
      if (option.account instanceof ExternalBankAccount) {
        array.push(option);
      }
    });
    return array;
  }
  get noOtherAccounts() {
    return this.externalBankAccounts.length === 0 && this.balances.length === 0;
  }
  selectSecondaryAccount(secondaryOptionId) {
    if (secondaryOptionId === 'add-external-bank-account') {
      if (this.args.showPlaidLink) {
        this.args.setPage('link-bank-info');
      } else {
        this.args.setPage('import-linked-bank');
      }
      return;
    }
    const secondaryOption = this.secondaryOptions.find(({
      id
    }) => {
      return id === secondaryOptionId;
    });
    if (secondaryOption) {
      this.currentTransfer.setSecondaryAccount(secondaryOption.account);
      this.validate();
    } else {
      throw new Error(`failed to find secondary account ${secondaryOptionId}`);
    }
  }
  updateTransferAmount(amount) {
    this.currentTransfer.setAmount(amount);
    this.validate();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentTransfer", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sfsCustomerApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sfsAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showValidation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "validation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onSubmit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showWithdrawalTransferLimit", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "showWithdrawalTransferLimit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDepositTransferLimit", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "showDepositTransferLimit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTransferLimit", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "showTransferLimit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxWithdrawalLimit", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "maxWithdrawalLimit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxDepositLimit", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "maxDepositLimit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxTransferLimit", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "maxTransferLimit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTransferError", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "showTransferError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "balances", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "balances"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "externalBankAccounts", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "externalBankAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "noOtherAccounts", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "noOtherAccounts"), _class.prototype), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "maxTransfer", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "selectSecondaryAccount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectSecondaryAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateTransferAmount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateTransferAmount"), _class.prototype)), _class));
export { EnterAmount as default };